const phoneNumberValidator = value => /\+[1-9][0-9]{5,13}$/u.test(value);

export const commonPhoneNumberValidation = phone => {
    return phone ? phoneNumberValidator(phone) : false;
};
